
<template>
  <div class="container-size">
    <popup :message="notif.alertErrMessage" v-if="notif.isAlertErr" @close="notif.isAlertErr = false" />
    <div class="checkout-event" v-if="!isConfirmPayment && !isNextCuration">
      <h1 class="text-center checkout-e-title">{{ $t('checkout.event.formTitle') }}</h1>
      <div class="card-item card-item-padding" @click="toggleDetail">
        <div class="d-flex justify-content-between">
          <p class="c-detail">{{ $t('checkout.event.classDetails') }}</p>
          <arrow :down="!isDetail" />
        </div>
        <div class="d-flex gap-2" v-if="isDetail">
          <div>
            <img :src="event.img_urls.desktop.purchase_detail" style="margin-right: 5px; border-radius: 15px" width="95"
              height="95" />
          </div>
          <div>
            <h3 class="class-name">{{ event.name }}</h3>
            <p class="harga">{{ $t('checkout.price.total') }}</p>
            <span class="price" v-if="!checkIsEarlyBird(event)">{{
              event.price ? toCurrency(event.price) : $t('checkout.price.free')
            }}</span>
            <div v-else class="mb-2">
              <span class="price mr-2">{{
                event.price - event.discount_price
                  ? toCurrency(event.price - event.discount_price)
                  : $t('checkout.price.free')
              }}</span>
              <p>
                <del>{{ toCurrency(event.price) }}</del><br /><span class="early-bird-promo">{{ event.label_discount
                }}</span>
              </p>
            </div>
          </div>
        </div>
        <div class="class-info" v-if="isDetail">
          <div class="class-info-content">
            <div class="mob">
              <img src="/img/icons/date.png" alt="Level training" width="20" height="20" />
              <span class="name font-poppins">{{ $t('checkout.event.date') }}</span>
            </div>
            <div class="class-info-detail">
              <span class="font-poppins">{{
                moment(event.session_schedules[0].date_start)
              }}</span>
            </div>
          </div>
          <div class="class-info-content">
            <div class="mob">
              <img src="/img/icons/clock.png" alt="Level training" width="20" height="20" />
              <span class="name font-poppins">{{ $t('checkout.event.time') }}</span>
            </div>
            <div class="class-info-detail">
              <span class="font-poppins">{{ event.session_schedules[0].start_time }} -
                {{ event.session_schedules[0].end_time }} {{ $t('general.timezone') }}</span>
            </div>
          </div>
          <div class="class-info-content">
            <div class="mob">
              <img src="/img/icons/methode.png" alt="Level training" width="20" height="20" />
              <span class="name font-poppins">{{ $t('checkout.form.method') }}</span>
            </div>
            <div class="class-info-detail">
              <span class="font-poppins">{{ event.method | toMethode }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="card-item">
        <div class="card-item-padding">
          <div class="input-box">
            <span>{{ $t('checkout.event.eventType') }}</span>
            <v-text-field v-model="event.category.name" outlined class="mt-2 rounded-sm" dense disabled></v-text-field>
          </div>
        </div>
        <div class="spacing-ctn"></div>
        <div class="card-item-padding">
          <div class="input-box">
            <span>{{ $t('checkout.form.genderLabel') }}</span>
            <v-radio-group row ref="gender" v-model="gender" :error-messages="genderErrors" @input="$v.gender.$touch()"
              @blur="$v.gender.$touch()" required>
              <v-radio v-for="(item, idx) in genders" :key="idx" class="font-poppins" :label="item"
                :value="item"></v-radio>
            </v-radio-group>
          </div>
          <div class="input-box">
            <span>{{ $t('checkout.form.fullNameLabel') }}</span>
            <v-text-field ref="fullName" v-model="fullName" outlined dense required
              :placeholder="$t('checkout.event.fullNamePlaceholder')" class="mt-2 rounded-sm"
              :error-messages="fullNameErrors" @input="$v.fullName.$touch()"
              @blur="$v.fullName.$touch()"></v-text-field>
          </div>
          <div class="input-box">
            <span>{{ $t('checkout.form.phoneNumberLabel') }}</span>
            <v-row>
              <v-col cols="3">
                <v-text-field :label="$t('checkout.form.countryCodeLabel')" outlined dense class="mt-2 rounded-sm"
                  value="+62" disabled></v-text-field>
              </v-col>
              <v-col>
                <v-text-field v-model="phoneNumber" outlined dense required
                  :placeholder="$t('checkout.event.phonePlaceholder')" class="mt-2 rounded-sm" type="number"
                  :error-messages="phoneNumberErrors" @input="$v.phoneNumber.$touch()"
                  @blur="$v.phoneNumber.$touch()"></v-text-field>
              </v-col>
            </v-row>
          </div>
          <div class="input-box">
            <span>{{ $t('checkout.form.emailLabel') }}</span>
            <v-text-field v-model="email" @keydown.space.prevent outlined dense required
              :placeholder="$t('checkout.event.emailPlaceholder')" class="mt-2 rounded-sm" :error-messages="emailErrors"
              @input="$v.email.$touch()" @blur="$v.email.$touch()"></v-text-field>
          </div>
          <div class="input-box">
            <span>{{ $t('checkout.form.birthdateLabel') }}</span>
            <v-text-field class="mb-2" v-model="birthdate" prepend-icon="mdi-calendar" type="date"
              :error-messages="birthdateErrors" @input="$v.birthdate.$touch()"
              @blur="$v.birthdate.$touch()"></v-text-field>
          </div>
          <div class="input-box">
            <span>{{ $t('checkout.event.institution') }}</span>
            <v-text-field ref="corporate_name" v-model="corporate_name" outlined dense required
              :placeholder="$t('checkout.event.institutionPlaceholder')" class="mt-2 rounded-sm"></v-text-field>
          </div>
        </div>
        <div class="spacing-ctn"></div>
        <div class="card-item-padding">
          <div class="input-box">
            <span>{{ $t('checkout.form.voucherCodeLabel') }}</span>
            <v-text-field v-model="voucherCode" outlined class="mt-2 rounded-sm" dense required clearable @click:clear="clearVoucher"></v-text-field>
          </div>
          <div class="aggrement" v-html="$t('checkout.form.agreement')"></div>
          <div class="button-checkout">
            <Button v-if="!event.is_curation" :name="$t('checkout.event.registerButton')" :disabled="validationField"
              width="320px" :loading="isLoading" @click="() => toCheckout(event.price ? false : true)" />
            <Button v-if="event.is_curation" :name="$t('checkout.event.nextButton')" :disabled="validationField"
              width="300px" @click="checkNextPage" />
          </div>
        </div>
      </div>
    </div>
    <div class="checkout-event" v-if="isConfirmPayment && !isNextCuration">
      <div class="card-item card-item-padding" style="margin-top: 170px">
        <h2 class="text-center" style="margin-bottom: 20px">
          {{ $t('checkout.event.paymentDetails') }}
        </h2>
        <div class="d-flex gap-2">
          <div>
            <img :src="event.img_urls.desktop.purchase_detail" style="margin-right: 5px; border-radius: 15px" width="95"
              height="95" />
          </div>
          <div>
            <h3 class="class-name">{{ event.name }}</h3>
            <div class="author-info">
              <span>{{ moment(event.session_schedules[0].date_start) }}</span>
              <span class="circle"></span>
              <span>{{ event.session_schedules[0].start_time }} {{ $t('general.timezone') }}</span>
              <span class="circle"></span>
              <span>{{ event.method | toMethode }}</span>
            </div>
          </div>
        </div>
        <hr class="mt-5" />
        <div style="margin: 15px 0">
          <div class="price-info">
            <span>{{ $t('checkout.event.subtotal') }}</span>
            <span v-if="checkIsEarlyBird(event)">{{
              (event.price - event.discount_price) | toCurrency
            }}</span>
            <span v-else>{{ event.price | toCurrency }}</span>
          </div>
          <div class="price-info">
            <span>{{ $t('checkout.event.discount') }}</span>
            <span>{{ discount ? toCurrency(discount) : "-" }}</span>
          </div>
        </div>
        <hr />
        <div class="price-info mt-5">
          <p class="price-title">{{ $t('checkout.price.total') }}</p>
          <p class="price-total" v-if="checkIsEarlyBird(event)">
            {{
              event.price - event.discount_price - discount
                ? toCurrency(event.price - event.discount_price - discount)
                : $t('checkout.price.free')
            }}
          </p>
          <p class="price-total" v-else>
            {{
              event.price - discount
                ? toCurrency(event.price - discount)
                : $t('checkout.price.free')
            }}
          </p>
        </div>
        <div class="button-checkout">
          <Button :name="$t('checkout.form.button')" width="320px" :loading="isLoading" @click="toCheckout" />
        </div>
      </div>
    </div>
    <div class="head-question" v-if="isNextCuration">
      <div class="form-container">
        <div v-for="(question, index) in questionCuration" :key="index" class="question-card">
          <p class="question-text">{{ question.question }} <span style="color: #c63c38; font-weight: bold;"
              v-if="question.correct_answer.length">*</span></p>
          <div v-if="question.isEssay">
            <textarea v-model="question.answer" :placeholder="$t('checkout.event.essayPlaceholder')"
              class="essay-input"></textarea>
          </div>
          <div v-else>
            <div v-for="(choice, choiceIndex) in question.choices" :key="choiceIndex" class="choice-container">
              <label class="radio-label">
                <input type="radio" :name="'question-' + index" :value="choice.description" v-model="question.answer"
                  class="radio-input" @change="trackCurationAnswer(index, choice.description)" />
                <span class="radio-custom"></span>
                {{ choice.description }}
              </label>
            </div>
            <div v-if="question.isOtherChoice" class="other-choice-container">
              <label class="radio-label">
                <input type="radio" :name="'question-' + index" value="other" v-model="question.answer"
                  class="radio-input" @change="trackCurationAnswer(index, 'other')" />
                <span class="radio-custom"></span>
                {{ $t('checkout.event.otherOption') }}:
              </label>
              <input type="text" v-if="question.answer === 'other'" v-model="otherAnswers[index]"
                :placeholder="$t('checkout.event.otherPlaceholder')" class="other-input"/>
            </div>
          </div>
        </div>
        <div class="page-2-confirm">
          <button class="back" rounded="0" variant="outlined" @click="backBtn">
            {{ $t('general.back') }}
          </button>
          <Button :name="$t('checkout.event.registerButton')" width="180px" :loading="isLoading"
            @click="() => toCheckout(event.price ? false : true)" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import Arrow from "@/assets/icons/Arrow.vue";
import Button from "@/components/others/Button.vue";
import { validationMixin } from "vuelidate";
import { required, email } from "vuelidate/lib/validators";
import Popup from "@/components/others/Popup.vue";

export default {
  name: "EventCheckout",
  components: {
    Arrow,
    Button,
    Popup,
  },
  mixins: [validationMixin],
  validations: {
    fullName: { required },
    phoneNumber: { required },
    birthdate: { required },
    gender: { required },
    email: { required, email },
  },
  data() {
    return {
      isDetail: true,
      isConfirmPayment: false,
      isLoading: false,
      questionCuration: [],
      otherAnswers: [],
      modal: false,
      isNextCuration: false,
      transactionId: 0,
      notif: {
        alertErrMessage: "",
        isAlertErr: false,
      },
      event: {
        name: "",
        registration_close_date: "",
        method: "",
        label: "",
        price: 0,
        img_urls: {
          desktop: {
            product_detail: "",
            purchase_detail: "",
            thumbnail: "",
          },
          mobile: {
            product_detail: "",
            purchase_detail: "",
            thumbnail: "",
          },
        },
        session_schedules: [
          {
            date_start: "",
          },
        ],
        category: {
          name: "",
        },
      },
      isDoubleClick: false,
      discount: 0,
      voucherCode: this.$route.query.rf,
      email: "",
      gender: "",
      fullName: "",
      phoneNumber: "",
      birthdate: "",
      corporate_name: "",
      is_curation: false,
      questions: [],
      genders: ["Tuan", "Nyonya", "Nona"],
    };
  },
  computed: {
    validationField() {
      if (
        this.email &&
        this.gender &&
        this.fullName &&
        this.birthdate &&
        this.phoneNumber
      ) {
        return false;
      } else {
        return true;
      }
    },
    fullNameErrors() {
      const errors = [];
      if (!this.$v.fullName.$dirty) return errors;
      !this.$v.fullName.required &&
        errors.push("Nama lengkap tidak boleh kosong.");
      return errors;
    },
    genderErrors() {
      const errors = [];
      if (!this.$v.gender.$dirty) return errors;
      !this.$v.gender.required && errors.push("Titel tidak boleh kosong");
      return errors;
    },
    emailErrors() {
      const errors = [];
      if (!this.$v.email.$dirty) return errors;
      !this.$v.email.email && errors.push("Must be valid email");
      !this.$v.email.required && errors.push("Email tidak boleh kosong");
      return errors;
    },
    phoneNumberErrors() {
      const errors = [];
      if (!this.$v.phoneNumber.$dirty) return errors;
      !this.$v.phoneNumber.required &&
        errors.push("Nomor telepon tidak boleh kosong.");
      return errors;
    },
    birthdateErrors() {
      const errors = [];
      if (!this.$v.birthdate.$dirty) return errors;
      !this.$v.birthdate.required &&
        errors.push("Tanggal lahir tidak boleh kosong.");
      return errors;
    },
  },
  watch: {
    "$i18n.locale"() {
      this.getEventDetail();
    },
  },
  methods: {
    async getEventDetail() {
      try {
        const resp = await this.$http.get(`/v2/event/${this.$route.params.id}`);
        const item = resp.data.data.event;
        this.event = {
          ...item,
          session_schedules: item.session_schedules
            ? item.session_schedules
              ? item.session_schedules
              : [
                {
                  date_end: "",
                  date_start: "",
                  end_time: "",
                  start_time: "",
                },
              ]
            : [
              {
                date_end: "",
                date_start: "",
                end_time: "",
                start_time: "",
              },
            ],
          img_urls: Object.keys(item.img_urls).length
            ? item.img_urls
            : {
              desktop: {
                product_detail: "",
                purchase_detail: "",
                thumbnail: "",
              },
              mobile: {
                product_detail: "",
                purchase_detail: "",
                thumbnail: "",
              },
            },
          expired: [],
        };
        if (this.event.is_curation) {
          this.questionCuration = this.event.questions.map((item) => ({
            ...item,
            answer: ""
          }));
        }
        this.$gtag.event('view', {
          event_category: 'Interaction',
          event_label: `View Event Details - ${this.event.name} - Event Checkout Page`,
          value: 1,
        });
      } catch (err) {
        console.log(err);
        this.$gtag.event('error', {
          event_category: 'Interaction',
          event_label: `Fetch Event Details Failed - Event ID ${this.$route.params.id} - Event Checkout Page`,
          value: 1,
        });
      }
    },
    moment(date) {
      return moment(date).format("dddd, DD MMMM YYYY");
    },
    toggleDetail() {
      this.isDetail = !this.isDetail;
      this.$gtag.event('click', {
        event_category: 'Interaction',
        event_label: `Toggle Event Details - ${this.event.name} - Event Checkout Page`,
        value: 1,
      });
    },
    trackCurationAnswer(index, answer) {
      this.$gtag.event('click', {
        event_category: 'Interaction',
        event_label: `Curation Answer Selected - Question ${index + 1} - Answer ${answer} - Event Checkout Page`,
        value: 1,
      });
    },
    clearVoucher() {
      this.voucherCode = '';
      this.discount = 0;
      this.$gtag.event('click', {
        event_category: 'Interaction',
        event_label: 'Clear Voucher - Event Checkout Page',
        value: 1,
      });
    },
    async checkNextPage() {
      if (this.phoneNumber.length < 10) {
        this.notif.isAlertErr = true;
        this.notif.alertErrMessage = "Nomor telepon tidak valid";
        this.$gtag.event('click', {
          event_category: 'Interaction',
          event_label: 'Proceed to Curation Failed - Invalid Phone Number - Event Checkout Page',
          value: 1,
        });
        return;
      }
      if (this.validationField) {
        this.notif.isAlertErr = true;
        this.notif.alertErrMessage = "Ups, semua data wajib diisi!";
        this.$gtag.event('click', {
          event_category: 'Interaction',
          event_label: 'Proceed to Curation Failed - Incomplete Data - Event Checkout Page',
          value: 1,
        });
        return;
      }
      this.$gtag.event('click', {
        event_category: 'Interaction',
        event_label: `Proceed to Curation Questions - ${this.event.name} - Event Checkout Page`,
        value: 1,
      });
      window.scrollTo(0, 0);
      this.isNextCuration = true;
    },
    async checkDiscountVoucher() {
      this.$gtag.event('click', {
        event_category: 'Interaction',
        event_label: `Apply Voucher - ${this.voucherCode} - Event Checkout Page`,
        value: 1,
      });
      try {
        const resp = await this.$http.get(`/v2/voucher/${this.voucherCode}?category_code=EVENT&class_category_id=${this.event.category.id}&class_id=${this.event.id}`);
        this.discount = resp.data.data.voucher.discount;
        return true;
      } catch (err) {
        this.isLoading = false;
        this.notif.isAlertErr = true;
        this.notif.alertErrMessage = "Voucher tidak di temukan";
        this.$gtag.event('click', {
          event_category: 'Interaction',
          event_label: `Apply Voucher Failed - ${this.voucherCode} - Event Checkout Page`,
          value: 1,
        });
        return false;
      }
    },
    async toCheckout(isFree = false) {
      if (this.phoneNumber.length < 10) {
        this.notif.isAlertErr = true;
        this.notif.alertErrMessage = "Nomor telepon tidak valid";
        this.$gtag.event('click', {
          event_category: 'Interaction',
          event_label: `Checkout Failed - Invalid Phone Number - ${this.event.name} - Event Checkout Page`,
          value: 1,
        });
        return;
      }
      if (this.validationField) {
        this.notif.isAlertErr = true;
        this.notif.alertErrMessage = "Ups, semua data wajib diisi!";
        this.$gtag.event('click', {
          event_category: 'Interaction',
          event_label: `Checkout Failed - Incomplete Data - ${this.event.name} - Event Checkout Page`,
          value: 1,
        });
        return;
      }
      this.$gtag.event('click', {
        event_category: 'Interaction',
        event_label: `Initiate Checkout - ${this.event.name} - Event Checkout Page`,
        value: 1,
      });
      if (this.event.is_curation) {
        this.questionCuration = this.questionCuration.map((item, idx) => {
          if (item.answer === 'other') {
            return {
              ...item,
              answer: this.otherAnswers[idx]
            };
          }
          return item;
        });
      }
      this.isLoading = true;
      if (isFree) {
        try {
          await this.$http.post("/v1/transaction-event", {
            event_id: this.event.id,
            type_event: this.event.category.name,
            batch: this.event.batch,
            title: this.gender,
            full_name: this.fullName,
            phone_number: this.phoneNumber,
            email: this.email,
            birthdate: this.birthdate,
            corporate_name: this.corporate_name,
            voucher_code: this.voucherCode,
            question: this.questionCuration,
          });
          this.isLoading = false;
          this.$gtag.event('click', {
            event_category: 'Interaction',
            event_label: `Checkout Success - Free Event - ${this.event.name} - Event Checkout Page`,
            value: 1,
          });
          this.$router.push("/event/success");
          return;
        } catch (err) {
          this.isLoading = false;
          this.notif.isAlertErr = true;
          this.notif.alertErrMessage = err.response.data.data;
          this.$gtag.event('click', {
            event_category: 'Interaction',
            event_label: `Checkout Failed - Free Event - ${this.event.name} - Event Checkout Page`,
            value: 1,
          });
          return;
        }
      }
      if (!this.isConfirmPayment) {
        if (this.voucherCode) {
          const checkVoucherTrue = await this.checkDiscountVoucher();
          if (!checkVoucherTrue) return;
        }
        try {
          const resp = await this.$http.post("/v1/transaction-event", {
            event_id: this.event.id,
            type_event: this.event.category.name,
            title: this.gender,
            full_name: this.fullName,
            batch: this.event.batch,
            phone_number: this.phoneNumber,
            email: this.email.toLowerCase(),
            birthdate: this.birthdate,
            corporate_name: this.corporate_name,
            voucher_code: this.voucherCode,
            question: this.questionCuration,
            is_paid: false,
          });
          this.transactionId = resp.data.data.transaction_id;
          if (resp.data.data.invoice_link) {
            window.open(resp.data.data.invoice_link);
            this.isLoading = false;
            this.$gtag.event('click', {
              event_category: 'Interaction',
              event_label: `Checkout Success - Invoice Generated - ${this.event.name} - Event Checkout Page`,
              value: 1,
            });
            this.$router.push("/event/success");
            return;
          }
          this.isConfirmPayment = true;
          this.isLoading = false;
          this.$gtag.event('click', {
            event_category: 'Interaction',
            event_label: `Proceed to Payment Page - ${this.event.name} - Event Checkout Page`,
            value: 1,
          });
        } catch (err) {
          this.isLoading = false;
          this.notif.isAlertErr = true;
          this.notif.alertErrMessage = err.response.data.data;
          this.$gtag.event('click', {
            event_category: 'Interaction',
            event_label: `Checkout Failed - ${this.event.name} - Event Checkout Page`,
            value: 1,
          });
        }
      } else {
        if (this.isDoubleClick) {
          setTimeout(() => {
            this.isDoubleClick = false;
          }, 3000);
          return;
        }
        this.isDoubleClick = true;
        this.$gtag.event('click', {
          event_category: 'Interaction',
          event_label: `Proceed to Payment - ${this.event.name} - Event Checkout Page`,
          value: 1,
        });
        try {
          let discount_price = 0;
          if (this.checkIsEarlyBird(this.event)) {
            discount_price = this.event.discount_price;
          }
          if (this.event.price - discount_price - this.discount > 0) {
            const resp = await this.$http.post(
              "/v1/transaction-event/send-payment",
              {
                transaction_id: this.transactionId,
              }
            );
            window.open(resp.data.data.url);
            this.$gtag.event('click', {
              event_category: 'Interaction',
              event_label: `Payment Initiated - ${this.event.name} - Event Checkout Page`,
              value: 1,
            });
          }
          this.isLoading = false;
          this.$router.push("/event/success");
        } catch (err) {
          this.isLoading = false;
          this.notif.isAlertErr = true;
          this.notif.alertErrMessage = err.response.data.data;
          this.$gtag.event('click', {
            event_category: 'Interaction',
            event_label: `Payment Failed - ${this.event.name} - Event Checkout Page`,
            value: 1,
          });
        }
      }
    },
    checkIsEarlyBird(item) {
      if (
        new Date(item.start_discount_date) <= new Date() &&
        new Date(item.end_discount_date) >= new Date() && !this.voucherCode
      ) {
        return true;
      } else {
        return false;
      }
    },
    toCurrency(value) {
      if (typeof value !== "number") {
        return value;
      }
      var formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "IDR",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      });
      return formatter.format(value);
    },
    privacyPolicy() {
      this.$gtag.event('click', {
        event_category: 'Navigation',
        event_label: 'Go to Privacy Policy - Event Checkout Page',
        value: 1,
      });
      this.$router.push("/privacy-policy");
    },
    termCondition() {
      this.$gtag.event('click', {
        event_category: 'Navigation',
        event_label: 'Go to Terms and Conditions - Event Checkout Page',
        value: 1,
      });
      this.$router.push("/term-condition");
    },
    backBtn() {
      window.scrollTo(0, 0);
      this.isNextCuration = false;
      this.$gtag.event('click', {
        event_category: 'Interaction',
        event_label: 'Back from Curation Questions - Event Checkout Page',
        value: 1,
      });
    }
  },
  mounted() {
    this.getEventDetail();
    this.$utils.scrollTop();
    this.$gtag.pageview(this.$route);
  },
};
</script>

<style scoped>
.checkout-event {
  width: 50%;
  margin: 50px auto;
}

.card-item {
  margin-top: 20px;
  border-radius: 26px !important;
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
}

.card-item-padding {
  padding: 20px 40px;
}

.card-item .harga {
  margin: 0;
  margin-top: 10px;
  color: #7b7e8c;
}

.card-item .price {
  font-weight: bolder;
  margin: 0;
  color: #162ca2;
  font-size: 18px;
  font-family: "Poppins", sans-serif !important;
}

.class-info {
  margin-top: 18px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 14px;
}

.class-info-content {
  gap: 8px;
}

.class-info-detail {
  display: flex;
  flex-direction: column;
}

.class-info-detail .name {
  color: #7b7e8c;
  font-size: 16px;
}

.class-info-content .mob {
  display: flex;
  gap: 10px;
}

.input-box span {
  display: block;
  font-weight: bold;
  font-size: 17px;
  margin-bottom: -3px;
  font-family: "Poppins", sans-serif !important;
}

.spacing-ctn {
  margin-top: -20px;
  background-color: #f5f6fa;
  height: 10px;
}

.rounded-sm {
  border-radius: 14px !important;
}

.early-bird-promo {
  color: #162ca2;
  font-size: 13px;
  font-weight: 500;
  font-family: "Poppins", sans-serif;
}

.aggrement {
  font-size: 15px;
  width: 80%;
  margin: auto;
  margin-top: 30px;
  text-align: center;
  font-family: "Poppins", sans-serif !important;
}

.button-checkout {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  margin-top: 18px;
}

.author-info {
  display: flex;
  gap: 10px;
  font-size: 14px;
  align-items: center;
  margin: 10px 0;
}

.circle {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background-color: gray;
}

.price-info {
  display: flex;
  justify-content: space-between;
}

.price-title {
  font-size: 22px;
  font-weight: bold;
}

.price-total {
  color: #b80f0a;
  font-size: 22px;
  font-weight: bold;
}

hr {
  border: 1px solid #d3d6e1;
}

.aggrement .info {
  color: #000080;
  font-weight: bold;
  cursor: pointer;
  font-family: "Poppins", sans-serif !important;
  background-color: white !important;
}

.c-detail {
  font-weight: bolder;
  font-size: 17px;
  font-family: "Poppins", sans-serif;
}

.form-container {
  max-width: 800px;
  margin: 0 auto;
}

.question-card {
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  padding: 20px;
  margin-bottom: 20px;
}

.question-text {
  font-size: 16px;
  font-weight: 500;
  color: #202124;
  margin-bottom: 20px;
}

.essay-input {
  width: 100%;
  height: 100px;
  padding: 10px;
  border: 1px solid #dadce0;
  border-radius: 4px;
  font-size: 14px;
  resize: vertical;
}

.radio-label {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  font-size: 14px;
  color: #202124;
  cursor: pointer;
}

.radio-input {
  display: none;
}

.radio-custom {
  width: 16px;
  height: 16px;
  border: 2px solid #5f6368;
  border-radius: 50%;
  margin-right: 10px;
  position: relative;
}

.radio-input:checked+.radio-custom {
  border-color: #1a73e8;
}

.radio-input:checked+.radio-custom::after {
  content: "";
  width: 8px;
  height: 8px;
  background-color: #1a73e8;
  border-radius: 50%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.other-choice-container {
  margin-top: 10px;
}

.other-input {
  margin-left: 26px;
  padding: 8px;
  border: 1px solid #dadce0;
  border-radius: 4px;
  font-size: 14px;
  width: calc(100% - 30px);
}

.head-question {
  background-color: #f5f5f5;
  padding-top: 80px;
  margin-bottom: -20px;
}

.back {
  background-color: #fff;
  color: #5f6368;
  border: 1px solid #dadce0;
  padding: 10px 20px;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  width: 180px;
}

.back:hover {
  background-color: #f1f3f4;
}

.submit {
  background-color: #1a73e8;
  color: white;
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  font-size: 16px;
}

.submit:hover {
  background-color: #1558b0;
}

.page-2-confirm {
  padding-bottom: 50px;
  display: flex;
  gap: 20px;
  justify-content: center;
}

@media screen and (max-width: 900px) {
  .checkout-e-title {
    display: none !important;
    font-size: 20px;
    line-height: 30px;
  }

  .checkout-event {
    width: 95%;
  }

  .card-item-padding {
    padding: 20px;
  }

  .class-info {
    display: block;
  }

  .class-info-content {
    margin-top: 10px;
    display: flex;
    justify-content: space-between;
  }

  .aggrement {
    width: 98%;
  }
}
</style>